import { render, staticRenderFns } from "./ReplyListCards.vue?vue&type=template&id=4d13c7ec&scoped=true&"
import script from "./ReplyListCards.vue?vue&type=script&lang=js&"
export * from "./ReplyListCards.vue?vue&type=script&lang=js&"
import style0 from "./ReplyListCards.vue?vue&type=style&index=0&id=4d13c7ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d13c7ec",
  null
  
)

export default component.exports